exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".consultation-message-pdf[data-v-94971e66]{width:70px}", ""]);

// exports
